import { React, StyledProps, withStyles, classNames } from '@api'
import { Add } from '@material-ui/icons'

const styles = theme => ({
  dropIndicator: {
    width: 250,
    height: 250,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(65, 132, 243, 0.56)'
  },
  medium_dropIndicator: {
    width: 160,
    height: 160,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(65, 132, 243, 0.56)'
  },
  addIcon: {
    width: 50,
    height: 50,
    color: '#FFF'
  }
})

interface MyProps extends StyledProps {
  type?: string
}

export class DropIndicatorComponent extends React.Component<MyProps> {
  static defaultProps = {
    type: 'large'
  }
  
  render () {
    const {classes, className, type} = this.props
    return (
      <div
           className={classNames(className, {[classes.dropIndicator]: type === 'large'}, {[classes.medium_dropIndicator]: type !== 'large'})}>
        <Add className={classes.addIcon}/>
      </div>
    )
  }
}

@(withStyles as any)(styles)
export class DropIndicator extends DropIndicatorComponent {}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/DropIndicator.tsx